import { INews } from '@core/interfaces/news.interface';

/** Table display only - strips HTML tags from the Quill-authored message so the datatable shows
 * plain text; the dialog's editor still works with the full HTML. */
export function stripHtmlTags(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  return (doc.body.textContent ?? '').trim();
}

/** True when a news item's language matches the currently selected language filter - used to keep
 * a newly created or edited item out of the table when it no longer matches what's shown, the same
 * way the store already filters on edit. */
export function matchesLanguageFilter(news: Pick<INews, 'languageCode'>, currentLanguageCode: string): boolean {
  return news.languageCode === currentLanguageCode;
}
